module.exports = __webpack_public_path__ + "static/media/london-41.8897da4a.vg";